import styled from "styled-components";
import { FieldDropdownListCss } from "../field-dropdown/FieldDropdown.styled";

export const FieldAutocompleteAddressStyled = styled.div`
  position: relative;
  z-index: 10;
`;

export const FieldAutocompleteAddressListStyled = styled.div`
  ${FieldDropdownListCss}
`;
